/* 
PUBLIC PAGE 
*/
import React from "react";
import LoginForm from '../Components/LoginForm/LoginForm';
import Layout from "../Components/Layout/Layout";

function LoginPage() {
  return (
    <Layout>
        <LoginForm />
    </Layout>
  );
}

export default LoginPage;
